import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.jg{padding-left:10px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.jh{padding:2px 0px;}.ssr-plugin'
import '.ab{height:1px;}.ssr-plugin'
import '.cc{padding-top:8px;}.ssr-plugin'
import { useState } from 'react'
import { format } from 'date-fns'
import { colors } from '../../tokens/colors.js'
import { Button } from '../Button/index.js'
import { Text } from '../Text/index.js'
import { DatePicker } from './DatePicker.js'
import { TimeInput } from './TimeInput.js'
import { DateTextInput } from './DateTextInput.js'
import { styled } from 'inlines'

export const DateTimePicker = ({
  value,
  onChange,
  placement,
  selectableRange,
}: {
  value?: number | Date
  onChange: (value: number) => void
  placement?: string
  selectableRange?: {
    min?: number | Date
    max?: number | Date
  }
}) => {
  const [view, setView] = useState('date')

  const [dateTextInputToggle, setDateTextInputToggle] = useState(true) // Changed to true

  return (
    <div className="a i a3">
      <div className="a ae d jg"
      >
        <Text variant="display-medium" color="neutral60">
          Date
        </Text>{' '}
        <DateTextInput // Always display DateTextInput
          value={value as Date}
          onChange={onChange}
          autoFocus
          onBlur={() => setDateTextInputToggle(false)}
        />
        {/* Removed the Button and conditional rendering */}
      </div>
      <div className="h jh">
        <div className="ab h"
          style={{ background: colors.neutral10 }}
        />
      </div>
      {view === 'date' && (
        <DatePicker
          value={value as Date}
          onChange={onChange}
          placement={placement}
          selectableRange={selectableRange}
        />
      )}
      {view === 'date' && (
        <div style={{ width: '100%', padding: '2px 0px' }}>
          <div
            style={{ height: 1, width: '100%', background: colors.neutral10 }}
          />
        </div>
      )}
      <div className="a ae d jg"
      >
        <Text variant="display-medium" color="neutral60">
          Time
        </Text>
        <TimeInput value={value as any} onChange={onChange as any} />
      </div>
      <div className="a ae d cc"
        style={{
          borderTop: `1px solid ${colors.neutral10}`,
        }}
      >
        <Button
          variant="ghost"
          color="red"
          onClick={() => {
            onChange(new Date(0) as any)
          }}
        >
          Clear
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            onChange(new Date() as any)
          }}
        >
          Set to now
        </Button>
      </div>
    </div>
  )
}
